import { Col, Container, Row } from 'react-bootstrap';
import Buttons from '../../../Litho/Components/Button/Buttons';
import PieChart from '../../../Litho/Components/PieChart/PieChart';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';

const PiechartData1 = [
	{
		percentage: 98,
		title: 'ON-TIME DELIVERY',
	},
	{
		percentage: 97,
		title: 'CUSTOMS CLEARANCE SUCCESS',
	},
	{
		percentage: 99,
		title: 'REAL-TIME TRACKING COVERAGE',
	},
];

const OurAchievements = () => {
	return (
		<section className='py-[130px] lg:py-[90px] home-business-piechart md:py-[75px] sm:[50px] bg-[#f7f8fc]'>
			<Container>
				<Row className='justify-center md:block'>
					<Col
						lg={5}
						sm={9}
						className='text-left flex-col items-start flex md:text-center md:my-0 md:mx-auto md:mb-[70px] md:items-center sm:mb-[65px]'
					>
						<div className='mb-[20px]'>
							<span className='inline-block font-serif text-md font-medium uppercase text-gradient bg-gradient-to-r from-[#556fff] via-[#e05fc4] to-[#ff798e]'>
								Our expertise
							</span>
						</div>
						<h5 className='w-[90%] mb-[20px] font-semibold text-darkgray font-serif sm:mb-[30px] xxs:w-full'>
							Air, road, and ocean logistics—fast, secure, and trackable
							worldwide
						</h5>
						<p className='w-[90%] text-md leading-7 text-[#828282] xxs:w-full'>
							From express air cargo to dependable road transport and
							cost-effective ocean freight, we keep your supply chain moving
							with end-to-end visibility and proactive support.
						</p>
						<Buttons
							href='/quote'
							className='font-medium font-serif uppercase bg-[#c82227] hover:bg-[#282a5f] md:mb-[15px] mt-[38px] sm:mt-6 sm:mx-auto rounded-full'
							size='sm'
							title='Get a quote'
						/>
					</Col>
					<Col lg={{ offset: 1 }}>
						<PieChart
							grid='justify-center gap-y-10 row-cols-1 row-cols-sm-2'
							className='text-left flex flex-col justify-center items-center md:text-center md:items-center'
							theme='piechart-style-02'
							data={PiechartData1}
							pathColor={['#c82227', '#282a5f']}
							trailColor='#f5f5f5'
							pathWidth={12}
							trailWidth={12}
							animation={fadeIn}
						/>
					</Col>
				</Row>
			</Container>
		</section>
	);
};

export default OurAchievements;
